import { getI18nStrings } from "../config/runtime";
import { activeClientLocale } from "./localePaths";

export function csrfToken() {
  return document.querySelector("meta[name='csrf-token']")?.content || "";
}

function updateCsrfTokenFromResponse(response) {
  const nextToken = response.headers.get("X-CSRF-Token");
  if (!nextToken) return;
  const el = document.querySelector("meta[name='csrf-token']");
  if (el) el.setAttribute("content", nextToken);
}

function acceptLanguageHeader() {
  return activeClientLocale() === "vi" ? "vi,en;q=0.9" : "en";
}

function errorMessageLocale() {
  return activeClientLocale();
}

export async function postJson(url, payload) {
  return requestJson(url, "POST", payload);
}

export async function getJson(url) {
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Accept-Language": acceptLanguageHeader(),
      "X-CSRF-Token": csrfToken(),
    },
    credentials: "same-origin",
  });
  updateCsrfTokenFromResponse(response);
  const json = await response.json().catch(() => ({}));
  if (!response.ok) {
    const table = typeof window !== "undefined" ? getI18nStrings() : null;
    const loc = errorMessageLocale();
    const fallback = table ? table[loc]?.http_request_failed || table.en?.http_request_failed : null;
    throw new Error(json.error || (json.errors && json.errors.join(", ")) || fallback || "Request failed.");
  }
  return json;
}

export async function patchJson(url, payload) {
  return requestJson(url, "PATCH", payload);
}

async function requestJson(url, method, payload) {
  const response = await fetch(url, {
    method,
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken(),
      Accept: "application/json",
      "Accept-Language": acceptLanguageHeader(),
    },
    credentials: "same-origin",
    body: JSON.stringify(payload),
  });
  updateCsrfTokenFromResponse(response);
  const json = await response.json().catch(() => ({}));
  if (!response.ok) {
    const table = typeof window !== "undefined" ? getI18nStrings() : null;
    const loc = errorMessageLocale();
    const fallback = table ? table[loc]?.http_request_failed || table.en?.http_request_failed : null;
    const error = new Error(json.error || (json.errors && json.errors.join(", ")) || fallback || "Request failed.");
    error.status = response.status;
    error.code = json.code || null;
    error.redirectTo = json.redirect_to || null;
    throw error;
  }
  return json;
}
